// src/types/tv.ts

import { SchoolEvent } from 'models/event';

export enum VIEW_TYPE {
  GAMES_LIST            = 'GAMES_LIST',
  GROUP_TABLE           = 'GROUP_TABLE',
  FINALS                = 'FINALS',
  TOP_PERFORMANCE       = 'TOP_PERFORMANCE',
  SINGLE_EVENT          = 'SINGLE_EVENT',
  GROUP_TABLE_MINI_TEAM = 'GROUP_TABLE_MINI_TEAM',
}

export interface ScreenDataModel {
  /**
   * Determines which “slide” template to render.
   * - SINGLE_EVENT: show a single‐event result
   * - GROUP_TABLE:   show a table of participants/results
   * - FINALS, etc.  (for later/other tournament types)
   */
  viewType: VIEW_TYPE;

  /** 
   * The title text that appears on top of the screen, e.g. “Year 10 Male 100m Finals”
   */
  groupWithAge: string;

  /**
   * The list of events to render on this slide. For SINGLE_EVENT, this will be exactly one event;
   * for GROUP_TABLE, it might be all events in that group, etc.
   */
  events: SchoolEvent[];

  // (only used by viewType === FINALS or GROUP_TABLE_MINI_TEAM)
  groupName?:   string;
  groupId?:     string;
  finalType?:   string;

  /**
   * For any “table” screen (GROUP_TABLE or GROUP_TABLE_MINI_TEAM), you can pass in
   * an array of “participants + scores” objects. For individual‐tournament logic, we
   * can leave this empty.
   */
  participantsData?: any[];
}
